/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { connect } from 'react-redux';
import {
    MenuItemContainer as SourceMenuItemContainer,
    mapStateToProps,
    mapDispatchToProps,
} from 'SourceComponent/MenuItem/MenuItem.container';
import React from "react";
import history from '@scandipwa/scandipwa/src/util/History';
import { scrollToTop } from '@scandipwa/scandipwa/src/util/Browser';

export {
    mapStateToProps,
    mapDispatchToProps,
};

/** @namespace Component/MenuItem/Container */
export class MenuItemContainer extends SourceMenuItemContainer {
    onItemClick() {
        const {
            closeMenu,
            updateBreadcrumbs,
            activeMenuItemsStack,
            item: {
                url,
            } = {},
        } = this.props;

        const newPathname = this.getPathname(url || '');

        scrollToTop();
        closeMenu();

        // keep the stack here, so later we can deconstruct menu out of it
        const { pathname } = location;

        history.push(pathname, { stack: activeMenuItemsStack });

        if (pathname !== newPathname) {
            updateBreadcrumbs();
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemContainer);
